import {MrLife} from '../../domain/models/memorepo/MrLife'

export type MrChangedLife = MrLife & {
    primaryLifeName?: string
}
